function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSelector } from 'reselect';
import pathOr from 'ramda/src/pathOr';
import clone from 'ramda/src/clone';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { pascalCaseKeys } from 'invision-core/src/utilities/object.formatting.helper';
import { SummaryTab } from '../helpers/offer.ordering.wizard.selector.helper';
import { EMPTY_ARRAY, EMPTY_OBJECT, FALSE } from '../constants/common.constants';
import { ASYNC_STATUS_CONSTANTS } from '../constants/wizard.constants';
import { PRICE_OVERRIDE_ACCESS } from '../../security.attributes';
var ADDITIONAL_PROPERTY_IS_ACTIVE = 'is_active';
export var DROP_DOWN_DEFAULT_ADDRESS = {
  Id: 0,
  Country: null,
  State: null,
  dropDownString: 'Add New'
};
var OfferingOrderSelector = function OfferingOrderSelector(state) {
  return state.customercare.offeringOrder;
};
export var OfferingOrderDataSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.data;
});
export var OfferingOrderFinanceCreditLimitSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.financeCreditLimitValidation;
});
export var OfferingOrderAsyncIdSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.asyncId;
});
export var OfferingOrderCheckoutPageEditFormSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.editCheckoutFormDetails;
});
export var AsyncStatusSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.asyncStatus;
});
export var IsQuoteBypassedSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isQuoteBypassed;
});
export var FullCartAsyncStatusSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.fullCartAsyncStatus;
});
export var IsFullCartAsyncCompleteSelector = createImmutableSelector([OfferingOrderAsyncIdSelector, FullCartAsyncStatusSelector], function (asyncId, fullCartAsyncStatus) {
  return asyncId ? fullCartAsyncStatus === ASYNC_STATUS_CONSTANTS.COMPLETE || fullCartAsyncStatus === ASYNC_STATUS_CONSTANTS.FAILED : true;
});
export var OffcycleRenewalScheduleSelector = createImmutableSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return pathOr(EMPTY_ARRAY, ['offcycleRenewalSchedule'], offeringOrderData);
});
export var DependentPricingPlansIdsSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.selectedOffering ? offeringOrderData.selectedOffering.pricingPlanIdsNotFulfillingRequiredPricingPlanConditions : null;
});
export var SelectedContractDefinitionSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.selectedContractDefinition;
});
export var IsFetchingActiveContractSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isFetchingActiveContract;
});
export var BillingEffectiveDateConfigurationSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.billingEffectiveDateConfiguration || EMPTY_OBJECT;
});
export var BillingEffectiveDateSettingsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return {
    minimumDate: billingEffectiveDateConfiguration.MinBillingEffectiveDate,
    pastDateMaxLength: billingEffectiveDateConfiguration.PastBillingEffectiveDateMaxLength
  };
});
export var BillingEffectiveDateOptionsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return billingEffectiveDateConfiguration.OrderExecutionToBillingEffectiveDateIntentions || EMPTY_ARRAY;
});
export var IsInventoryStoreConfiguredSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.Stores)], function (stores) {
  return !!stores.length;
});
export var OfferingQuickViewSelector = function OfferingQuickViewSelector(state) {
  return pathOr(null, ['customercare', 'offeringOrder', 'quickView'], state);
};
export var RetrieveOfferingContextQuickViewErrorSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.retrieveOfferingContextQuickViewError;
});
export var IsRetrievingOfferingContextQuickView = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isRetrievingOfferingContextQuickView;
});
export var AvailableOfferingsDataSelector = createSelector([OfferingOrderDataSelector], function (orderStoreData) {
  return orderStoreData.availableOfferings.data;
});
export var IsPostpaidEnabledSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.isPostpaidEnabled;
});
export var IsPrepaidEnabledSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.isPrepaidEnabled;
});
var OfferingsDisplayOrderSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.offeringsDisplayOrder;
});
export var OfferingsSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.offeringsMap;
});
export var OffersSelector = createSelector([OfferingsDisplayOrderSelector, OfferingsSelector], function () {
  var displayOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var offerings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return displayOrder ? displayOrder.map(function (offeringId) {
    return offerings[offeringId];
  }) : [];
});
export var IsFetchingSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isFetchingData;
});
export var ViewLastAttemptErrorSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.lastAttemptError;
});
export var PageNumberSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.pageNumber;
});
export var RecordCountSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.recordCount;
});
export var SelectedPageSizePreference = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.pageSizePreference;
});
export var NumberOfPagesSelector = createSelector([AvailableOfferingsDataSelector], function (availableOfferingsData) {
  return availableOfferingsData.pageCount;
});
export var CreatedOrderSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.createdOrder;
});
export var CreatedOrderCurrencyCodeSelector = createSelector([CreatedOrderSelector], function (createdOrder) {
  return createdOrder && createdOrder.Currency ? createdOrder.Currency : 'USD';
});
export var IsSubmittingOrderSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isSubmittingOrder;
});
export var IsQuotingOfferSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isCalculatingQuote;
});
export var SubTotalAmountSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.subTotal;
});
export var TaxAmountSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.taxAmount;
});
export var TotalAmountSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.totalAmount;
});
export var TotalRemainingAmountSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.totalRemainingAmount;
});
export var QuoteCalculatedSelector = createSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.quoteCalculated;
});
export var OfferingOrderQuoteSelector = createImmutableSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.offeringOrderQuote;
});
export var QuickViewShoppingCartSelector = createSelector([OfferingQuickViewSelector], function (quickView) {
  var shoppingCart = pathOr(null, ['shoppingCart'], quickView);
  return shoppingCart ? shoppingCart.asMutable({
    deep: true
  }) : {};
});
export var IsAsyncCompleteSelector = createImmutableSelector([OfferingOrderAsyncIdSelector, AsyncStatusSelector], function (offeringOrderAsyncId, asyncStatus) {
  return offeringOrderAsyncId ? asyncStatus === ASYNC_STATUS_CONSTANTS.COMPLETE || asyncStatus === ASYNC_STATUS_CONSTANTS.FAILED : true;
});
export var QuickViewSubTotalSelector = createSelector([OfferingQuickViewSelector], function (quickView) {
  return pathOr(0, ['shoppingCart', 'BillerRuleTotals', 'Amount'], quickView);
});
export var QuickViewTotalAmountSelector = createSelector([OfferingQuickViewSelector], function (quickView) {
  return pathOr(0, ['shoppingCart', 'BillerRuleTotals', 'TotalAmount'], quickView);
});
export var QuickViewPreQuoteDueSubTotalsSelector = createImmutableSelector([QuickViewShoppingCartSelector], function (quickViewShoppingCart) {
  var subTotalDueToday = pathOr(0, ['SubTotals', 'DueToday'], quickViewShoppingCart);
  var subTotalDueNextInvoice = pathOr(0, ['SubTotals', 'DueNextInvoice'], quickViewShoppingCart);
  var subTotalDueRecurring = pathOr(0, ['SubTotals', 'DueRecurring'], quickViewShoppingCart);
  var subTotalDueOnActivation = pathOr(0, ['SubTotals', 'DueOnActivation'], quickViewShoppingCart);
  var subTotalDueOnFirstUse = pathOr(0, ['SubTotals', 'DueOnFirstUse'], quickViewShoppingCart);
  return {
    dueToday: {
      subTotal: subTotalDueToday
    },
    dueNextInvoice: {
      subTotal: subTotalDueNextInvoice
    },
    dueOnActivation: {
      subTotal: subTotalDueOnActivation
    },
    dueOnFirstUse: {
      subTotal: subTotalDueOnFirstUse
    },
    dueRecurring: {
      subTotal: subTotalDueRecurring
    }
  };
});
export var QuickViewSummaryTabViewModel = SummaryTab([QuickViewShoppingCartSelector, QuickViewSubTotalSelector, function () {
  return 0;
}, QuickViewTotalAmountSelector, function () {
  return false;
}, function () {
  return false;
}, function () {
  return false;
}, function () {
  return false;
}, function () {
  return false;
}, function () {
  return false;
}, QuickViewPreQuoteDueSubTotalsSelector]);
export var TransitioningEnabledSelector = createSelector([OfferingOrderSelector], function (offering) {
  return offering.transitioningEnabled;
});
export var TransitioningContextErrorSelector = createSelector([OfferingOrderSelector], function (offering) {
  return offering.transitioningContextError;
});
export var SubscriptionOrderQuoteSelector = createSelector([OfferingOrderSelector], function (offering) {
  return offering.subscriptionOrderQuote;
});
export var SelectedInventoryStoresSelector = createImmutableSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.inventoryStore.selectedStores;
});
export var InventoryRegionFilterSelector = createImmutableSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.inventoryStore.regionFilter;
});
export var IsInventoryStoreChangedSelector = createImmutableSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.inventoryStore.isStoreChanged;
});
export var FormattedInventoryStoresSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.Stores)], function (stores) {
  var activeStores = stores.filter(function (store) {
    return store.AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === ADDITIONAL_PROPERTY_IS_ACTIVE;
    }).Value !== FALSE;
  });
  return activeStores.map(function (store) {
    return Object.assign({}, store, {
      AdditionalProperties: pascalCaseKeys(store.AdditionalProperties.reduce(function (additionalProperties, property) {
        additionalProperties[property.Key] = property.Value;
        return additionalProperties;
      }, {}))
    });
  });
});
export var SelectedInventoryRegionSelector = createImmutableSelector([SelectedInventoryStoresSelector, FormattedInventoryStoresSelector], function (selectedStores, stores) {
  if (selectedStores.length) {
    return pathOr(null, ['AdditionalProperties', 'RegionCode'], stores.find(function (store) {
      return store.Value === selectedStores[0];
    }));
  }
  return null;
});
export var SelectedInventoryStoresDetailsSelector = createImmutableSelector([SelectedInventoryStoresSelector, FormattedInventoryStoresSelector], function (selectedStores, storesDetails) {
  return selectedStores.map(function (selectedStoreId) {
    return storesDetails.find(function (store) {
      return store.Value === selectedStoreId;
    });
  });
});
export var InventoryStoresTableDataSelector = createImmutableSelector([InventoryRegionFilterSelector, FormattedInventoryStoresSelector, MetadataCodeTypeSelector(CODES.InventoryRegion)], function (regionFilter, stores, regions) {
  var shippableRegion = regions.filter(function (region) {
    return region.AdditionalProperties.find(function (item) {
      return item.Key === 'is_shipping_available' && item.Value === 'True';
    });
  });
  var filteredStore = [];
  if (shippableRegion.length) {
    filteredStore = stores.filter(function (store) {
      return store.AdditionalProperties.RegionCode !== shippableRegion[0].Value;
    });
  } else {
    filteredStore = stores;
  }
  return filteredStore.reduce(function (storesTableData, store) {
    if (regionFilter && store.AdditionalProperties.RegionCode !== regionFilter) {
      return storesTableData;
    }
    storesTableData.push({
      address: "".concat(store.AdditionalProperties.LineOne, " ").concat(store.AdditionalProperties.LineTwo),
      city: store.AdditionalProperties.City,
      description: store.Description,
      displayName: store.AdditionalProperties.DisplayName,
      name: store.Name,
      postalCode: store.AdditionalProperties.Zipcode,
      region: store.AdditionalProperties.RegionCode,
      stateProvince: store.AdditionalProperties.StateProvince,
      storeId: store.Value
    });
    return storesTableData;
  }, []);
});
export var ServiceFeatureSelector = createImmutableSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.serviceFeature;
});
export var StandalonesSelector = createImmutableSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.standalones;
});
export var ServiceFeatureProductsSelector = createImmutableSelector([ServiceFeatureSelector], function (serviceFeature) {
  return serviceFeature.products;
});
export var ProductMetadataStatusSelector = createImmutableSelector([ServiceFeatureSelector], function (serviceFeature) {
  return serviceFeature.productMetadataLoaded;
});
export var ServiceFeatureProductsFormattedSelector = createImmutableSelector([ServiceFeatureProductsSelector], function (serviceFeatureProducts) {
  return Object.values(serviceFeatureProducts);
});
export var ServiceFeatureOrdereablePricingPlansSelector = createImmutableSelector([ServiceFeatureSelector], function (serviceFeature) {
  return serviceFeature.orderablePricingPlansByProductId;
});
export var ServiceFeaturesCardinalitySelector = createImmutableSelector([ServiceFeatureSelector], function (serviceFeature) {
  return serviceFeature.serviceFeatureCardinality;
});
export var ServiceFeatureProductsMetadataSelector = createImmutableSelector([ServiceFeatureSelector], function (serviceFeature) {
  return serviceFeature.productMetadataByProductId;
});
export var StandaloneProductsMetadataSelector = createImmutableSelector([StandalonesSelector], function (standalones) {
  return standalones.productMetadataByProductId;
});
var getOrderablePricingPlans = function getOrderablePricingPlans(metadata, orderablePricingPlans, hasPriceOverrideAccess) {
  var filteredPricingPlans = (metadata.PricingPlans || EMPTY_ARRAY).filter(function (pricingPlan) {
    return (orderablePricingPlans || EMPTY_ARRAY).some(function (orderablePricingPlan) {
      return orderablePricingPlan.Id === pricingPlan.Id;
    });
  });
  filteredPricingPlans.forEach(function (filteredPricingPlan) {
    var orderablePricingPlan = orderablePricingPlans.find(function (orderablePricingPlan) {
      return filteredPricingPlan.Id === orderablePricingPlan.Id;
    });
    if (orderablePricingPlan) {
      var pricingPlanRAndOBRIs = filteredPricingPlan && filteredPricingPlan.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(filteredPricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(filteredPricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
      filteredPricingPlan.billerRuleInstances = orderablePricingPlan.BillerRuleInstanceThumbnails.map(function (brit) {
        brit.chargeAmount = brit.Amount;
        brit.discountAmount = brit.DiscountAmount;
        brit.hasDiscount = !!brit.DiscountAmount;
        brit.name = pricingPlanRAndOBRIs.find(function (_ref) {
          var BillerRuleConfigurationId = _ref.BillerRuleConfigurationId;
          return brit.BillerRuleConfigurationId === BillerRuleConfigurationId;
        }).Name;
        brit.isOverrideable = hasPriceOverrideAccess && pricingPlanRAndOBRIs.some(function (pricingPlanBRI) {
          return pricingPlanBRI.Id === brit.Id && pricingPlanBRI.AllowChargeOverride;
        });
        brit.isOverrideSelected = false;
        return brit;
      });
    }
  });
  return filteredPricingPlans;
};
export var ServiceFeaturesViewModelSelector = createImmutableSelector([ServiceFeatureProductsFormattedSelector, ServiceFeatureOrdereablePricingPlansSelector, ServiceFeatureProductsMetadataSelector, ServiceFeaturesCardinalitySelector, UserSecurityAttributesSelector, ProductMetadataStatusSelector], function (products, orderablePricingPlans, productsMetadata, serviceCardinality, userSecurityAttributes, isProductMetadataLoaded) {
  return products.map(function (product) {
    //Todo: Implement hydration / selected pricing plans in ASC-101329 and tie into serviceFeatures component
    var metadata = productsMetadata[product.Id] || EMPTY_OBJECT;
    var pricingPlans = orderablePricingPlans[product.Id];
    var hasPricingPlanInformation = !!(product.Id && Object.keys(orderablePricingPlans).length && Object.keys(metadata).length);
    return {
      description: metadata.Description,
      hasPricingPlanInformation: hasPricingPlanInformation,
      id: product.Id,
      max: product.MaxNonBulkQuantity,
      maximumQuantity: serviceCardinality[product.Id] ? serviceCardinality[product.Id].MaximumQuantity : null,
      minimumQuantity: serviceCardinality[product.Id] ? serviceCardinality[product.Id].MinimumQuantity : null,
      name: product.Name,
      pricingPlans: hasPricingPlanInformation ? getOrderablePricingPlans(clone(metadata), clone(pricingPlans), hasAccess(userSecurityAttributes, PRICE_OVERRIDE_ACCESS)) : EMPTY_ARRAY,
      showNoPricingPlanMessage: isProductMetadataLoaded && !(pricingPlans !== null && pricingPlans !== void 0 && pricingPlans.length)
    };
  });
});
export var IsSendingInventoryToStoreSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isSendingInventoryToStore;
});
export var InventoryStorePickupDetailsSelector = createImmutableSelector([OfferingOrderDataSelector], function (offeringOrderData) {
  return offeringOrderData.inventoryStorePickupDetails;
});
export var SearchInventoryAvailabilityErrorSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.searchInventoryAvailabilityError;
});
export var IsUpdatingMultiOfferShoppingCart = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.isUpdatingMultiOfferShoppingCart;
});
export var OfferingOrderOffCycleAlignmentSelector = createSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder.offCycleAlignmentOptions;
});
export var SelectedOrderExecutionOptionsSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder && offeringOrder.executionOptions || EMPTY_OBJECT;
});
export var SelectedOrderDetailsSelector = createImmutableSelector([OfferingOrderSelector], function (offeringOrder) {
  return offeringOrder && offeringOrder.orderDetails || EMPTY_OBJECT;
});
export var DbssShippingEnabledRegionIdSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.InventoryRegion)], function (inventoryRegions) {
  var shippingEnabledInventoryRegion = (inventoryRegions || []).find(function (region) {
    return region.AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === 'is_shipping_available' && additionalProperty.Value === 'True';
    });
  });
  return shippingEnabledInventoryRegion ? shippingEnabledInventoryRegion.Value : undefined;
});
export var SelectedDeliveryDecisionSelector = createImmutableSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.selectedDeliveryDecision;
});
export var DbssShippingWarehouseIdSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.Stores), DbssShippingEnabledRegionIdSelector], function (stores, shippingEnabledRegionId) {
  var warehouse = stores.find(function (store) {
    return store.AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === 'region_code' && additionalProperty.Value === shippingEnabledRegionId;
    });
  });
  return (warehouse || {}).Value;
});
export var SelectedShippingAddressAndMethodSelector = createImmutableSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.selectedAddressDetails || undefined;
});
export var SelectedShippingAddressFromDropDownSelector = createSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.setSelectedShippingAddress || DROP_DOWN_DEFAULT_ADDRESS;
});
export var UpdatedShippingAddressSelector = createSelector([OfferingOrderSelector], function (offeringStore) {
  return offeringStore.setUpdatedShippingAddress || DROP_DOWN_DEFAULT_ADDRESS;
});
export var InventoryRegionWithoutWarehouseSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.InventoryRegion)], function (regions) {
  var filteredRegions = regions.filter(function (region) {
    return region.AdditionalProperties.find(function (item) {
      return item.Key === 'is_shipping_available' && item.Value === 'False';
    });
  });
  return filteredRegions && filteredRegions.map(function (code) {
    return {
      label: code.Name,
      value: code.Value
    };
  });
});